import React from 'react';
import {
  LogoImage,
  FormBox,
  TitleSection,
  ResetButton,
  ResetContainer,
  ResetInput,
  ResetTitle,
  ResetWraper,
  ResetPhrase,
  InputContainer,
  InputIcon,
  RememberPassword,
  SigninLink,
  LogoWrapper
} from './styles';
import logoImage from '../../assets/soji_logo.svg';
import mailIcon from '../../assets/mail_icon.svg';
import { useNavigate } from 'react-router-dom';
import { ResetPasswordValidation } from './validation';
import { useFormik } from 'formik';
import { useUserResetPasswordMutation } from '../../store/auth/api';
import { showErrorToast, showSuccessToast } from '../../utils/toast';

const PasswordReset = () => {
  const navigate = useNavigate();
  const [resetPassword, { isLoading }] = useUserResetPasswordMutation();

  const handleResetPassword = (values: { email: string }) => {
    resetPassword(values)
      .unwrap()
      .then((result) => {
        showSuccessToast(result.message);
        navigate('/check-email');
      })
      .catch((err) => {
        showErrorToast(err.message);
      });
  };
  const { values, handleChange, handleSubmit } = useFormik({
    initialValues: { email: '' },
    validationSchema: ResetPasswordValidation,
    onSubmit: handleResetPassword
  });
  return (
    <>
      <ResetWraper>
        <LogoWrapper>
          <LogoImage src={logoImage} alt="logo" />
        </LogoWrapper>
        <ResetContainer>
          <FormBox onSubmit={handleSubmit}>
            <TitleSection>
              <ResetTitle>Forgot password</ResetTitle>
            </TitleSection>
            <ResetPhrase>
              Enter the email linked to your account, we will send you a code to
              recover your password
            </ResetPhrase>
            <InputContainer>
              <InputIcon src={mailIcon} alt="" />
              <ResetInput
                value={values.email}
                onChange={handleChange('email')}
                placeholder="Enter email address"
              ></ResetInput>
            </InputContainer>
            <ResetButton
              isLoading={isLoading}
              type={'submit'}
              buttonText={'Proceed'}
            />
            <RememberPassword>
              Remember? <SigninLink to={'/'}>Sign in</SigninLink>
            </RememberPassword>
          </FormBox>
        </ResetContainer>
      </ResetWraper>
    </>
  );
};

export default PasswordReset;
